import RecentCalls from "./RecentCalls";
import AgentStatus from "../Agentstatus";
import LiveCalls from "./Livecalls";
import UseAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useAuth from "../../../hooks/useAuth";

import { useState, useEffect } from "react";
import AvailableBalance from "./AvailableBalance";

function RightBar(props) {
  const { auth } = useAuth();
  const user_id = auth?.user_details?.id;

  const [active, setActive] = useState("RecentCall");

  const axiosPrivate = UseAxiosPrivate();

  // ------------------  Live Calls Data  -------------------- //
  const [liveCallData, setLiveCallData] = useState([]);

  // -------------------- Fetch Live Calls ------------------- //

  const FetchLiveCalls = async () => {
    let config = {
      headers: { "Content-Type": "application/json" },
    };

    await axiosPrivate
      .get(
        process.env.REACT_APP_API_URL +
          "/contactcentre/live-calls/" +
          user_id +
          "/",
        {},
        config
      )
      .then((response) => {
        setLiveCallData(response.data); // Assuming the response contains the data you need
        setActive("LiveCall");

      })
      .catch((error) => {
        console.error("Error fetching live call data:", error);
      });
  };

  // useEffect(()=>{
  //   alert(active)
  // },[active])

  const FetchCreditData = async () => {
    let config = {
      headers: { "Content-Type": "application/json" },
    };

    await axiosPrivate
      .get(
        process.env.REACT_APP_API_URL +
          "/contactcentre/credit/" +
          user_id +
          "/",
        {},
        config
      )
      .then((response) => {
        props.setCreditData(response.data); // Assuming the response contains the data you need
        setActive("Balance");
      })
      .catch((error) => {
        console.error("Error fetching live call data:", error);
      });
  };

  return (
    <div>
      <div className="flex justify-between p-6 space-x-4 bg-back-white rounded-t-lg">
        <div className="flex justify-between w-[30rem] ml-5">
          <div>
              <style>
              {`
                  @keyframes blinkShadow {
                    0%, 100% {
                      text-shadow: 0px 0px 3px rgb(255, 0, 0);
                      color: white;
                      }
                      50% {
                        text-shadow: 0px 0px 3px rgba(70, 70, 70, 0.05);
                        color: rgba(3, 228, 89, 0.9);
                    }
                  }
              `}
              </style>
              <div className="flex justify-between w-[18rem]">
                <button 
                  
                  style={
                    props.creditData?.credit_status==='No Credit' || props.creditData?.credit_status === "Too Low"?
                    {
                      textShadow: "0px 0px 3px rgb(255, 0, 0)",
                      animation: "blinkShadow 0.75s ease-in-out infinite",
                      fontWeight: 600,
                    }:{}
                  }

                  className={`text-center ${
                    active === "Balance" ? "text-[#2ACC6A]" : "text-slate-500"
                  } font-bold text-lg`}
                  onClick={FetchCreditData}
                >
                  Balance
                </button>
                <button
                  className={`text-center ${
                    active === "LiveCall" ? "text-[#2ACC6A]" : "text-slate-500"
                  } font-bold text-lg`}
                  onClick={FetchLiveCalls}
                >
                  Live Calls
                </button>
                <button
                  className={`text-center ${
                    active === "RecentCall" ? "text-[#2ACC6A]" : "text-slate-500"
                  } font-bold text-lg`}
                  onClick={() => setActive("RecentCall")}
                >
                  Recent Calls
                </button>
              </div>
          {/* <hr className="w-6/5 mx-6 space-x-1 h-[1px]  bg-gray-100 border-0 rounded  mt-[-11px]" /> */}
          <hr
            className={`h-[0.3rem] mt-[12px] rounded border-0
            bg-gradient-to-r from-[#AFD462] via-[#7ecfa6] to-[#93e5ea]
            transition-all duration-1Z00 ease-in-out
            ${
              active === "Balance"
                ? "w-[6rem] ml-[-5%]"
                : active === "LiveCall"
                ? "w-[6rem] ml-[28%] "
                : active === "RecentCall"
                ? "w-[6rem] ml-[66%] "
                : "w-0"
            }`}
          />
          </div>

          <button
            type="button"
            to={"/admin/campaign/list"}
            className="max-[1666px]:h-10 h-7 max-[1666px]:mt-[-0.2rem] mt-0.5 inline-block px-4 py-1.5 bg-yellow-500 text-white font-karla text-[12px] leading-tight rounded-full shadow-md hover:bg-yellow-600 hover:shadow-lg focus:bg-yellow-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-yellow-700 active:shadow-lg transition duration-150 ease-in-out"
          >
            Show More
          </button>
        </div>
      </div>


      <div className="">
        <div className="rounded-lg bg-back-white h-[48rem]">
          {active === "Balance" && (
            <AvailableBalance user_id={user_id} creditData={props.creditData}/>
          )}
          {active === "LiveCall" && <LiveCalls liveCallData={liveCallData} />}
          {active === "RecentCall" && (
            <RecentCalls recentCalls={props.recentCalls} />
          )}
        </div>
        <div className="mt-4 bg-white rounded-lg  h-[43rem]">
          <AgentStatus agentstatus={props.agentstatus} />
        </div>
      </div>
    </div>
  );
}
export default RightBar;
